import React from "react";
import { Modal, Button } from "react-bootstrap";

const SuccessModal = ({ show, handleClose, report }) => {

  const handleContinue = () => {
    handleClose(); 
    window.location.reload(); 
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h5 className="fw-bold">Report Successfully Sent</h5>
        <br />
        <br />
        <p>Workflow report has been successfully sent to Issuer</p>
        <br />
        <br />
        <Button variant="primary" onClick={handleContinue}>
          Continue
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
